/**
 * Curated public names. Nominatim gives a hamlet; the news gives a fire.
 * Add a row when a campaign has a name people will search. Key is the stable incident id.
 * Applied on the live panel, Events cards, archive theater, SEO, and alerts.
 */
export type NamedEvent = {
  id: string;
  name: string;
  /** Desk note — not shown in the UI. */
  note: string;
};

export const NAMED_EVENTS: NamedEvent[] = [
  {
    id: "inc_4c9539a2",
    name: "Peñas de Riglos",
    note: "Huesca / Aragón, from 10 Aug 2026 — ~16,600 ha. Winner after the Bailo lobe folded in.",
  },
  {
    id: "inc_d092e5cd",
    name: "Peñas de Riglos",
    note: "Southern lobe — absorbed into inc_4c9539a2. Name kept so old permalinks still read as the campaign.",
  },
  {
    id: "inc_83107d98",
    name: "Niebla",
    note: "Huelva–Seville, from 6 Aug 2026 — ~38,000 ha. Press: incendio de Niebla. Centroid sat on Aznalcóllar.",
  },
  {
    id: "inc_4447384e",
    name: "Mount Etna",
    note: "Zafferana Etnea thermal — Aug 2026 Etna eruption, not a vegetation wildfire. News name is Etna.",
  },
  {
    id: "inc_bbcdd89d",
    name: "Boticas",
    note: "Vila Real, Ardãos e Bobadela, from 16 Aug 2026. Portuguese Civil Protection / Lusa.",
  },
  {
    id: "inc_c539d5e2",
    name: "High Fens",
    note: "Hautes Fagnes / Jalhay–Waimes, from 14 Aug 2026. Belgium's record blaze in English press.",
  },
  {
    id: "inc_f2294600",
    name: "Monte Morrone",
    note: "Abruzzo, Corfinio–Popoli / Maiella, from 9 Aug 2026. Italian press: incendio sul Morrone.",
  },
  {
    id: "inc_622c7177",
    name: "Carrazeda de Ansiães",
    note: "Douro / Bragança. Local press names the concelho; Aug 2026 restarts in the same municipality.",
  },
  {
    id: "inc_a4de734b",
    name: "Danube Delta — Chilia Veche",
    note: "Tulcea reed / forest fire on the Romanian delta. Recurring Chilia Veche story.",
  },
  {
    id: "inc_ab52637a",
    name: "Danube Delta",
    note: "Same delta complex, centroid toward the Chilia arm. Public catalog country is RO.",
  },
];

const BY_ID = new Map(NAMED_EVENTS.map((e) => [e.id, e.name]));

export function namedEvent(id: string): string | null {
  return BY_ID.get(id) ?? null;
}

/** Pinned name wins over Nominatim / catalog geocode. */
export function resolveEventName(id: string, fallback: string | null | undefined): string | null {
  return namedEvent(id) ?? fallback ?? null;
}
